import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../../Components/Modal/modal'; // Verify this path matches your project structure
import './ChangeMilestoneModal.scss';

const ChangeMilestoneModal = ({ milestoneStatuses, invoiceStatuses, onUpdate, onCancel, isLoading }) => {
  const [replannedDueDate, setReplannedDueDate] = useState('');
  const [milestoneStatusId, setMilestoneStatusId] = useState('');
  const [invoiceStatusId, setInvoiceStatusId] = useState('');

  const handleUpdate = () => {
    onUpdate({
      replannedDueDate,
      milestoneStatusId,
      invoiceStatusId,
    });
  };

  const dialogContent = (
    <div className="change-milestone-modal-content">
      <div className="form-row">
        <div className="form-group">
          <label>Replanned Due Date</label>
          <input
            type="date"
            className="form-control"
            value={replannedDueDate}
            onChange={(value) => setReplannedDueDate(value.target.value)}
            disabled={isLoading}
            placeholder="Replanned Due Date"
          />
        </div>
        <div className="form-group">
          <label>Milestone Status</label>
          <select
            className="form-control"
            value={milestoneStatusId}
            onChange={(value) => setMilestoneStatusId(value.target.value)}
            disabled={isLoading}
          >
            <option value="">Select</option>
            {milestoneStatuses.map((value) => (
              <option key={value.value} value={value.value}>{value.label}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Invoice Status</label>
          <select
            className="form-control"
            value={invoiceStatusId}
            onChange={(value) => setInvoiceStatusId(value.target.value)}
            disabled={isLoading}
          >
            <option value="">Select</option>
            {invoiceStatuses.map((value) => (
              <option key={value.value} value={value.value}>{value.label}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );

  return (
    <FormDialog
      title="Change Milestone Details"
      open={true}
      handleClose={onCancel}
      dialogBodycontent={dialogContent}
      button1="Cancel"
      button2={isLoading ? 'Submitting...' : 'Submit'}
      button1Action={onCancel}
      button2Action={handleUpdate}
      button2Disabled={isLoading || (!replannedDueDate && !milestoneStatusId && !invoiceStatusId)}
      dialogCss="change-milestone-dialog"
    />
  );
};

ChangeMilestoneModal.propTypes = {
  milestoneStatuses: PropTypes.array,
  invoiceStatuses: PropTypes.array,
  onUpdate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

ChangeMilestoneModal.defaultProps = {
  milestoneStatuses: [],
  invoiceStatuses: [],
  isLoading: false,
};

export default ChangeMilestoneModal;
